import React, { useEffect, useState } from "react";
import * as bootstrap from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";
import { Axios } from "../axios/Axios";
import {
  BlobProvider,
  Document,
  Page,
  Text,
  Font,
  StyleSheet,
  View,
} from "@react-pdf/renderer";

import Roboto from "./downloads/Roboto-Regular.ttf";
import Tangerine from "./downloads/Tangerine-Regular.ttf";
const TRACKING_ID = "UA-5168202-7";
ReactGA.initialize(TRACKING_ID);

export const ThankYou = (props) => {
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  const { t, i18n } = useTranslation();
  const [emailSent, setEmailSent] = useState(false);
  const location = useLocation();
  Font.register({
    family: "Lato",
    src: `https://fonts.gstatic.com/s/lato/v16/S6uyw4BMUTPHjx4wWw.ttf`,
  });
  Font.register({
    family: "Lato Bold",
    src: `https://fonts.gstatic.com/s/lato/v16/S6u9w4BMUTPHh6UVSwiPHA.ttf`,
  });
  Font.register({
      family: "Tangerine Regular",
      src: Tangerine,
  });

  const styles = StyleSheet.create({
    title: {
      fontSize: 14,
      textAlign: "center",
      textDecoration: "underline",
      fontFamily: "Lato Bold",
    },
    text: {
      margin: 1,
      fontSize: 12,
      textAlign: "justify",
      fontFamily: "Lato",
    },
    sigText: {
      margin: 1,
      fontSize: 12,
      textAlign: "justify",
        fontFamily: "Tangerine Regular",
        textDecoration: "underline",
    },
    boldText: {
      margin: 1,
      fontSize: 12,
      textAlign: "justify",
      fontFamily: "Lato Bold",
    },
    underlineText: {
      margin: 3,
      fontSize: 12,
      textAlign: "justify",
      fontFamily: "Lato Bold",
      textDecoration: "underline",
    },
    underline: {
      fontSize: 12,
      textAlign: "justify",
      fontFamily: "Lato",
      textDecoration: "underline",
    },
    borderText: {
      fontSize: 12,
      textAlign: "justify",
      fontFamily: "Lato Bold",
      fontWeight: "bold",
      borderWidth: 2,
      borderColor: "black",
      borderStyle: "solid",
    },
    borderTextArea: {
      margin: 12,
      fontSize: 12,
      width: "100%",
      minHeight: 40,
      textAlign: "justify",
      fontFamily: "Lato Bold",
      fontWeight: "bold",
      borderWidth: 2,
      borderColor: "black",
      borderStyle: "solid",
    },
    pageNumber: {
      position: "absolute",
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: "center",
      color: "grey",
    },
    container: {
      flex: 1,
      paddingTop: 40,
      paddingBottom: 65,
      paddingLeft: 35,
      paddingRight: 35,
      "@media max-width: 400": {
        paddingTop: 10,
        paddingLeft: 0,
      },
    },
    entryContainer: {
      marginBottom: 10,
    },
    headerContainer: {
      flexDirection: "row",
      marginBottom: 10,
    },
    leftColumn: {
      flexDirection: "column",
      flexGrow: 1,
    },
    rightColumn: {
      flexDirection: "column",
      flexGrow: 11,
      alignItems: "flex-end",
      justifySelf: "flex-end",
    },
    leftInfoColumn: {
      flexDirection: "column",
    },
    rightInfoColumn: {
      flexDirection: "column",
      flexGrow: 5,
      alignItems: "flex-start",
      justifySelf: "flex-start",
    },
    tableContainer: {
      flexDirection: "row",
    },
    spacerColumn: {
      flexDirection: "column",
      flexGrow: 5,
    },
    leftTableColumn: {
      flexDirection: "column",
      justifySelf: "flex-start",
    },
    rightTableColumn: {
      flexDirection: "column",
      flexGrow: 4,
      justifySelf: "flex-start",
    },
    tableStyle: {
      display: "table",
      width: "auto",
    },
    tableRowStyle: {
      flexDirection: "row",
    },
    firstTableColHeaderStyle: {
      width: "25%",
      borderStyle: "solid",
      borderColor: "#000",
      borderBottomColor: "#000",
      borderWidth: 1,
      backgroundColor: "#bdbdbd",
    },
    tableColHeaderStyle: {
      width: "25%",
      borderStyle: "solid",
      borderColor: "#000",
      borderBottomColor: "#000",
      borderWidth: 1,
      borderLeftWidth: 0,
      backgroundColor: "#bdbdbd",
    },
    tableColHeaderStyleBlank: {
      width: "25%",
    },
    firstTableColStyle: {
      width: "25%",
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderTopWidth: 0,
    },
    tableColStyle: {
      width: "25%",
      borderStyle: "solid",
      borderColor: "#000",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableColStyleBlank: {
      width: "25%",
    },
    tableCellHeaderStyle: {
      textAlign: "center",
      margin: 4,
      fontSize: 12,
      fontWeight: "bold",
    },
    tableCellHeaderStyle: {
      textAlign: "center",
      margin: 4,
      fontSize: 12,
      fontWeight: "bold",
    },
    tableCellStyle: {
      textAlign: "center",
      margin: 5,
      fontSize: 10,
      fontFamily: "Lato",
    },
  });
  const MyDoc = (
    <Document>
      <Page style={styles.container}>
        <Text style={styles.title}>{t("pdf.a")}</Text>
        <Text style={styles.boldText}>{t("pdf.b")}</Text>
        <Text style={styles.underlineText}>{t("pdf.c")}</Text>
        <Text style={styles.text}>{t("pdf.d")}</Text>
        <Text style={styles.text}>
          {t("pdf.e")} {location.state.formData.verifyCode}
        </Text>
        <Text style={styles.underlineText}>{t("pdf.f")}</Text>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.g")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.custNum}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.h")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.company}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.i")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.address}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.j")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.city}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.k")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.state}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.l")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.postalCode}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.m")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.name}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.n")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.title}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>P{t("pdf.o")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.phoneNumber}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>E{t("pdf.p")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.email}
            </Text>
          </View>
        </View>
        <Text style={styles.underlineText}>{t("pdf.q")}</Text>
        <View style={styles.headerContainer}>
          <View style={styles.leftColumn}>
            <Text style={styles.borderText}> X </Text>
          </View>
          <View style={styles.rightColumn}>
            <Text style={styles.text}>{t("pdf.r")}</Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftColumn}>
            <Text style={styles.borderText}> X </Text>
          </View>
          <View style={styles.rightColumn}>
            <Text style={styles.text}>{t("pdf.s")}</Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftColumn}>
            <Text style={styles.borderText}> X </Text>
          </View>
          <View style={styles.rightColumn}>
            <Text style={styles.text}>{t("pdf.t")}</Text>
          </View>
        </View>
        <Text style={styles.text}>{t("pdf.u")}</Text>
        <View style={styles.tableStyle}>
          <View style={styles.tableRowStyle}>
            <View style={styles.tableColHeaderStyleBlank}>
              <Text style={styles.tableCellHeaderStyle}></Text>
            </View>
            <View style={styles.firstTableColHeaderStyle}>
              <Text style={styles.tableCellHeaderStyle}></Text>
            </View>
            <View style={styles.tableColHeaderStyle}>
              <Text style={styles.tableCellHeaderStyle}>{t("pdf.table1")}</Text>
            </View>
            <View style={styles.tableColHeaderStyleBlank}>
              <Text style={styles.tableCellHeaderStyle}></Text>
            </View>
          </View>

          <View style={styles.tableRowStyle}>
            <View style={styles.tableColStyleBlank}>
              <Text style={styles.tableCellStyle}></Text>
            </View>
            <View style={styles.firstTableColStyle}>
              <Text style={styles.tableCellStyle}>{t("pdf.table2")}</Text>
            </View>
            <View style={styles.tableColStyle}>
              <Text style={styles.tableCellStyle}>
                {location.state.formData.qtyOnHand}
              </Text>
            </View>
            <View style={styles.tableColStyleBlank}>
              <Text style={styles.tableCellStyle}></Text>
            </View>
          </View>

          <View style={styles.tableRowStyle}>
            <View style={styles.tableColStyleBlank}>
              <Text style={styles.tableCellStyle}></Text>
            </View>
            <View style={styles.firstTableColStyle}>
              <Text style={styles.tableCellStyle}>{t("pdf.table3")}</Text>
            </View>
            <View style={styles.tableColStyle}>
              <Text style={styles.tableCellStyle}>
                {location.state.formData.qtySold}
              </Text>
            </View>
            <View style={styles.tableColStyleBlank}>
              <Text style={styles.tableCellStyle}></Text>
            </View>
          </View>

          <View style={styles.tableRowStyle}>
            <View style={styles.tableColStyleBlank}>
              <Text style={styles.tableCellStyle}></Text>
            </View>
            <View style={styles.firstTableColStyle}>
              <Text style={styles.tableCellStyle}>{t("pdf.table4")}</Text>
            </View>
            <View style={styles.tableColStyle}>
              <Text style={styles.tableCellStyle}>
                {location.state.formData.qtyInService}
              </Text>
            </View>
            <View style={styles.tableColStyleBlank}>
              <Text style={styles.tableCellStyle}></Text>
            </View>
          </View>

          <View style={styles.tableRowStyle}>
            <View style={styles.tableColStyleBlank}>
              <Text style={styles.tableCellStyle}></Text>
            </View>
            <View style={styles.firstTableColStyle}>
              <Text style={styles.tableCellStyle}>{t("pdf.table5")}</Text>
            </View>
            <View style={styles.tableColStyle}>
              <Text style={styles.tableCellStyle}>
                {location.state.formData.qtyTotal}
              </Text>
            </View>
            <View style={styles.tableColStyleBlank}>
              <Text style={styles.tableCellStyle}></Text>
            </View>
          </View>
        </View>
        <Text style={styles.text}>{t("pdf.v")}</Text>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.text}>{t("pdf.v1")}</Text>
          </View>
          {location.state.id && (
            <View style={styles.rightInfoColumn}>
              <Text style={styles.borderText}> X </Text>
            </View>
          )}
          <View style={styles.leftInfoColumn}>
            <Text style={styles.text}>{t("pdf.v2")}</Text>
          </View>
          {!location.state.id && (
            <View style={styles.rightInfoColumn}>
              <Text style={styles.borderText}> X </Text>
            </View>
          )}
        </View>
        <Text style={styles.text}>{t("pdf.v3")}</Text>
        <Text style={styles.underlineText}>{t("pdf.w")}</Text>
        <Text style={styles.borderTextArea}>
          {location.state.formData.injuryDetail}
        </Text>
        <Text style={styles.underlineText}>{t("pdf.x")}</Text>
        <Text style={styles.borderTextArea}>
          {location.state.formData.comments}
        </Text>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.y")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.sigText]}>
              {location.state.formData.signature}
            </Text>
          </View>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.z")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.datePicker}
            </Text>
          </View>
        </View>
        <View style={styles.headerContainer}>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.zA")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.name}
            </Text>
          </View>
          <View style={styles.leftInfoColumn}>
            <Text style={styles.boldText}>{t("pdf.zB")}</Text>
          </View>
          <View style={styles.rightInfoColumn}>
            <Text style={[styles.text, styles.underline]}>
              {location.state.formData.title}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );

  return (
    <div className="text-center">
      <bootstrap.Container>
        <bootstrap.Row>
          <bootstrap.Col>
            <h2 className="fw-bold py-4">{t("thankYou.thankYou")}</h2>
            <bootstrap.Card>
              <bootstrap.Card.Body>
                <p className="lead py-2">
                  {t("thankYou.registrationID")} {location.state.id}
                </p>
                <p className="lead py-2">{t("thankYou.message1")}</p>
                <p className="lead py-2">{t("thankYou.message2")}</p>
                <BlobProvider document={MyDoc}>
                  {({ blob, url, loading, error }) => {
                    if (blob) {
                      var file = new File(
                        [blob],
                        location.state.formData.verifyCode + ".pdf",
                        {
                          lastModified: new Date().getTime(),
                        }
                      );
                      if (!emailSent) {
                        Axios.email(
                          location.state.formData,
                          location.state.id,
                          file
                        );
                        setEmailSent(true);
                      }
                    }
                  }}
                </BlobProvider>
              </bootstrap.Card.Body>
            </bootstrap.Card>
          </bootstrap.Col>
        </bootstrap.Row>
      </bootstrap.Container>
    </div>
  );
};
